import { Tag } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/Pages/Test/Types/TestQuestion';
import api from '@Services/api';
import { DropdownProduct } from '@Features/dropdowns/dropdownsSlice.types';
import {
	DropdownsInstructorResponseType,
	DropdownsCategoriesResponseType,
	DropdownsBatchesResponseType,
	DropdownsClassroomsResponseType,
	DropdownsCoursesResponseType,
	DropdownsUnitsResponseType,
	DropdownsTestAttemptsResponseType,
} from '@Services/dropdowns/dropdowns.api.types';

export const fetchInstructorsDropdownRequest = () =>
	api.get<DropdownsInstructorResponseType>('dropdown/instructors');

export const fetchCategoriesDropdownRequest = () =>
	api.get<DropdownsCategoriesResponseType>('dropdown/categories');

export const fetchBatchesDropdownRequest = () =>
	api.get<DropdownsBatchesResponseType>('dropdown/batches');
export const fetchWalletBatchesDropdownRequest = () =>
	api.get<DropdownsBatchesResponseType>('dropdown/recharge-cards-batches');

export const fetchClassroomsDropdownRequest = () =>
	api.get<DropdownsClassroomsResponseType>('dropdown/classrooms');

export const fetchCoursesDropdownRequest = (classroomId: number | undefined) =>
	api.get<DropdownsCoursesResponseType>(`dropdown/courses/${classroomId}`);
export const fetchUnitsDropdownRequest = (courseId: number | undefined) =>
	api.get<DropdownsUnitsResponseType>(`dropdown/units/${courseId}`);
export const fetchTestAttemptsDropdownRequest = (
	unitId: number | undefined,
	userId?: number | undefined
) =>
	api.get<DropdownsTestAttemptsResponseType>(
		`dropdown/test/attempts/${unitId}/${userId}`
	);
export const fetchTagsDropdownRequest = () =>
	api.get<ApiResponse<Tag[]>>(`dropdown/tags`);

// Owner-scoped product lists for the promo-codes target selects; the backend
// resolves the owner from the token (assistants act for their parent).
export const fetchStandaloneCoursesDropdownRequest = () =>
	api.get<ApiResponse<DropdownProduct[]>>('dropdown/standalone-courses');

export const fetchBundlesDropdownRequest = () =>
	api.get<ApiResponse<DropdownProduct[]>>('dropdown/bundles');
